import { currentPageUrl } from "../../services/page-url";
import { fireLinkClick, firePageView } from "../../services/analytics";

/** What a control hands over, as plain strings, so a Server Component can pass it. */
export interface NavOpenReport {
  /** The click's reported name, already lower case. */
  linkName: string;
  /** The control's placement, one of the LINK_POSITION_* constants. */
  linkPosition: string;
  /** Path segment after the page URL; the page view's placement is `modal_[panel]`. */
  panel: string;
}

/** `[page absolute URL]/[panel]`, lower case, origin and path only. */
export function panelDestination(panel: string): string {
  return `${currentPageUrl().replace(/\/+$/, "")}/${panel}`;
}

/**
 * Reports an opening click, from a handler only. ⚠ `pageView` stays off for the
 * cart: its sheet reports its own, and a second would count the open twice.
 */
export function reportNavPanelOpen({
  linkName,
  linkPosition,
  panel,
  pageView = false
}: NavOpenReport & { pageView?: boolean }): void {
  const linkDestination = panelDestination(panel);
  fireLinkClick({
    linkName,
    linkPosition,
    linkDestination
  });
  if (pageView) {
    firePageView({
      linkPosition: `modal_${panel}`,
      linkDestination
    });
  }
}
